// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Col, SchemaTable, View } from "@components";
import type { ReferralOutcome } from "@modules/service/reducer/referrals/types";

type OwnProps = $Exact<{
  data: Array<ReferralOutcome>,
  schema: Object,
  onChange: (data: Array<ReferralOutcome>) => void | boolean,
  disabled?: boolean,
  addItemButtonText?: string,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

export class CommonOutcomeInputForm extends React.Component<Props> {
  get defaultProps() {
    return {
      addItemButtonText: this.props.addItemButtonText || this.props.t("ADD_OUTCOME"),
    };
  }

  get defaultOutcomes() {
    return [
      {
        id: null,
        outcome: "",
        isActive: true,
      },
    ];
  }

  get data() {
    return this.props.data && this.props.data.length ? this.props.data : this.defaultOutcomes;
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": ["outcome", "isActive"],
      outcome: {
        "ui:title": this.props.t("OUTCOME"),
        "ui:widget": "text",
        "ui:options": {
          disabled: (item: Object) => !item.isActive,
          required: true,
          editable: true,
          minWidth: "85%",
        },
      },
      isActive: {
        "ui:title": this.props.t("STATUS"),
        "ui:widget": "switch",
        "ui:options": {
          editable: true,
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange([...this.data, ...this.defaultOutcomes]);
  };

  handleChange = (data: Array<ReferralOutcome>) => {
    this.props.onChange([...data]);
  };

  render() {
    return (
      <View>
        {this.props.disabled ? null : (
          <View direction="row" justifyContent="end">
            <Button
              className="link eap-rsu__add-button"
              onClick={this.handleAdd}
              materialIcon="add"
              label={this.defaultProps.addItemButtonText}
            />
          </View>
        )}

        {this.schema && this.uiSchema ? (
          <SchemaTable
            tableData={this.data}
            schema={this.schema}
            uiSchema={this.uiSchema}
            onChange={this.handleChange}
            disabled={!!this.props.disabled}
            allowDeletes
          />
        ) : null}
      </View>
    );
  }
}

export default localize()(CommonOutcomeInputForm);
